module.exports = __webpack_public_path__ + "img/logo_placeholder.3ecb1b76.png";